import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAudiences', 'audiences'),
  ...generateMutations('getAudience', 'audience'),
}
